import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { MessageCircle, Check, AlertTriangle, BookOpen, ExternalLink } from "lucide-react";
import { Loading } from "@/components/States";

const POINTS = ["Parlare di TCG", "Mostrare le proprie collezioni", "Chiedere consigli", "Condividere esperienze", "Conoscere altri collezionisti", "Discutere degli scambi"];

export default function Community() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/site/config").then((r) => setCfg(r.data)).catch(() => setCfg({})); }, []);
  if (!cfg) return <Loading />;
  const configured = cfg.discord_configured && cfg.discord_invite;

  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="font-display text-3xl font-bold text-[#F8FAFC] sm:text-4xl">La community su Telegram</h1>
      <p className="mt-3 text-lg text-[#CBD5E1]">Le conversazioni di Omniverse vivono su Telegram. È il luogo dove conoscere altri appassionati e partecipare ogni giorno.</p>

      <div className="mt-8 rounded-2xl border border-[#2A3655] bg-[#141B2D] p-6">
        <h2 className="font-display text-xl font-semibold text-[#F8FAFC]">Nella community puoi</h2>
        <ul className="mt-4 grid gap-2 sm:grid-cols-2">
          {POINTS.map((p) => <li key={p} className="flex items-center gap-2 text-sm text-[#CBD5E1]"><Check className="h-4 w-4 shrink-0 text-[#2DD4BF]" />{p}</li>)}
        </ul>
      </div>

      <div className="mt-6 rounded-2xl border border-[#2A3655] bg-[#1C2640] p-6">
        <div className="flex items-center gap-3"><div className="grid h-11 w-11 place-items-center rounded-xl bg-[#229ED9]/20"><MessageCircle className="h-5 w-5 text-[#5BBEEB]" /></div>
          <div><h2 className="font-display text-xl font-semibold text-[#F8FAFC]">Entra nel gruppo Telegram</h2><p className="text-sm text-[#94A3B8]">Non serve un account Omniverse per aprire l'invito.</p></div>
        </div>
        <div className="mt-4 rounded-lg border border-[#F59E0B]/30 bg-[#F59E0B]/10 p-3 text-sm text-[#CBD5E1]">
          <p className="flex items-start gap-2"><BookOpen className="mt-0.5 h-4 w-4 shrink-0 text-[#F59E0B]" />Prima di entrare, leggi il <Link to="/regolamento" className="text-[#2DD4BF] hover:underline">regolamento della community</Link>.</p>
        </div>
        <div className="mt-4">
          {configured ? (
            <Button asChild size="lg" className="bg-[#229ED9] hover:bg-[#1C8BC0]"><a href={cfg.discord_invite} target="_blank" rel="noopener noreferrer" data-testid="telegram-invite-link">Apri l'invito Telegram <ExternalLink className="ml-2 h-4 w-4" /></a></Button>
          ) : (
            <div className="rounded-lg border border-[#2A3655] bg-[#0B1020] p-4" data-testid="telegram-not-configured">
              <p className="flex items-center gap-2 text-sm font-semibold text-[#F59E0B]"><AlertTriangle className="h-4 w-4" />Invito non ancora configurato</p>
              <p className="mt-1 text-sm text-[#94A3B8]">Il link al gruppo Telegram non è stato ancora impostato dall'amministratore. Torna a breve: l'ingresso alla community sarà attivo appena l'invito verrà configurato.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
